import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import { Autocomplete, Button } from "@mui/material";
import { Typography } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import "./fuel.scss";

import FormControlLabel from "@mui/material/FormControlLabel";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import {
  addNewVehicle,
  editVehicle,
  fetchVehicle,
  fetchVehicleById,
  fetchVehicleGroup,
} from "../../store/slices/Vehicle/thunk";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import {
  addNewFuel,
  editFuel,
  fetchDriver,
  fetchFuelById,
} from "../../store/slices/thunk";
import Spinner from "react-bootstrap/esm/Spinner";

const Addfuel = () => {
  const [addFuel, setAddFuel] = useState({
    vehicle: {
      vehicleId: "",
      vehicleName: "",
    },
    driver: {
      driverId: "",
      driverName: "",
    },
    fillDate: 0,
    quantity: "",
    odometerReading: "",
    amount: "",
    comment: "",
    _id: "",
  });

  const [allDriver, setAllDriver] = useState([]);

  const { id } = useParams<any>();
  const navigate = useNavigate();
  const [isEdit, setIsEdit] = useState(false);
  const dispatch: any = useDispatch();
  const [getAllVehicle, setAllVehicle] = useState([]);
  const [searchVehicle, setSearchVehicle] = React.useState("");
  const [searchDriver, setSearchDriver] = React.useState("");
  const [totalCount, setTotalCount] = useState(0);
    const DEBOUNCE_DELAY = 500;
    const ITEMS_PER_PAGE = 10;
    const pageCount = Math.ceil(totalCount / ITEMS_PER_PAGE);
    const [loading, setLoading] = useState(false);


  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        setIsEdit(true);
        const response: any = await dispatch(fetchFuelById(id));

        const {
          vehicle,
          driver,
          fillDate,
          quantity,
          odometerReading,
          amount,
          comment,
          _id,
        } = response.data;

        setAddFuel({
          vehicle: {
            vehicleId: vehicle?.vehicleId || "",
            vehicleName: vehicle?.vehicleName || "",
          },
          driver: {
            driverId: driver?.driverId || "",
            driverName: driver?.driverName || "",
          },
          fillDate: fillDate || "",
          quantity: quantity || "",
          odometerReading: odometerReading || "",
          amount: amount || "",
          comment: comment || "",
          _id: _id || "",
        });

        console.log("Fetched Maintenance:", response.data);
      } else {
        setIsEdit(false);
        setAddFuel({
          vehicle: {
            vehicleId: "",
            vehicleName: "",
          },
          driver: {
            driverId: "",
            driverName: "",
          },
          fillDate: 0,
          quantity: "",
          odometerReading: "",
          amount: "",
          comment: "",
          _id: "",
        });
      }
    };

    fetchData();
  }, [id, navigate, dispatch]);

  useEffect(() => {
      const handler = setTimeout(async () => {
        const response = await dispatch(fetchVehicle(1, 10, searchVehicle));
        if (response && response?.data && response?.data?.data && response?.data?.data?.length && response?.isSuccess) {
          setAllVehicle(response?.data?.data);
          setTotalCount(response?.data?.totalCount);
        } else {
          setAllVehicle([]);
          setTotalCount(0);
        }
      }, DEBOUNCE_DELAY);
      return () => {
        clearTimeout(handler);
      }
    }, [searchVehicle, dispatch]);
  

     useEffect(() => {
        const handler = setTimeout(async () => {
          const response = await dispatch(fetchDriver(1, 10, searchDriver));
          if (response && response?.data && response?.data?.data && response?.data?.data?.length && response?.isSuccess) {
            setAllDriver(response?.data?.data);
            setTotalCount(response?.data?.totalCount);
          } else {
            setAllDriver([]);
            setTotalCount(0);
          }
        }, DEBOUNCE_DELAY);
        return () => {
          clearTimeout(handler);
        }
      }, [searchDriver, dispatch]);

  const handleChangeForVehicle = (e: any) => {
    const { value } = e.target;

      if (!value) {
      // Jab user ne selection clear kar diya
      setAddFuel({
        ...addFuel,
        vehicle: {
          vehicleId: "",
          vehicleName: "",
        },
      });
      return;
    }

    const selectedVehicle: any = getAllVehicle.find(
      (vehicle: any) => vehicle._id === value
    );

    if (selectedVehicle) {
      setAddFuel({
        ...addFuel,
        vehicle: {
          vehicleId: selectedVehicle._id,
          vehicleName: selectedVehicle.vehicleName,
        },
      });
    }
  };
  const handleChangeForDriver = (e: any) => {
    const { value } = e.target;

    if (!value) {
      // Jab user ne selection clear kar diya
      setAddFuel({
        ...addFuel,
        driver: {
          driverId: "",
          driverName: "",
        },
      });
      return;
    }

    const selectedDriver: any = allDriver.find(
      (driver: any) => driver._id === value
    );

    if (selectedDriver) {
      setAddFuel({
        ...addFuel,
        driver: {
          driverId: selectedDriver._id,
          driverName: selectedDriver.driverName,
        },
      });
    }
  };
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setAddFuel((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
 const navigateToFuelList = () => {
    navigate("/fuel-list");
  };
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    console.log("Sending:", addFuel);
    setLoading(true);

    try {
      const {
        vehicle,
        driver,
        fillDate,
        quantity,
        odometerReading,
        amount,
        comment,
      } = addFuel;
      if (
        vehicle.vehicleId === "" ||
        vehicle.vehicleName === "" ||
        driver.driverId === "" ||
        driver.driverName === "" ||
        fillDate === 0 ||
        quantity.trim() === "" ||
        odometerReading.trim() === "" ||
        amount.trim() === "" ||
        comment.trim() === ""
      ) {
        toast.error("Fill all required fields!");
        return;
      }

      if (isEdit) {
        const res: any = await dispatch(editFuel(addFuel));
        if (res.data && res.isSuccess) {
          console.log("Success:", res);
          toast.success("Fuel Updated!");
          navigate("/fuel-list");
        } else {
          toast.error("Fuel Not Updated!");
        }
      } else {
        const res: any = await dispatch(addNewFuel(addFuel));
        if (res.data && res.isSuccess) {
          console.log("Success:", res);
          toast.success("Fuel Added!");
          navigate("/fuel-list");
        } else {
          toast.error("Fuel Not Added!");
        }
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
          <ToastContainer />
    
      <div className="boDy">
        {" "}
<div className="head d-flex justify-content-lg-between justify-content-start flex-column flex-lg-row flex-wrap">
          <div className="d-flex flex-column">
                                                <h2 className="fw-bold fs-4" style={{ color: "#1F2937" }}>{isEdit ? "Edit Fuel Record" : "Add New Fuel Record"}</h2>

            <p style={{ color: "#4B5563" }}>Fill in the fuel information below</p>
          </div>
          <button
            type="button"
            onClick={navigateToFuelList}
            className="btn rounded-2"
            style={{ backgroundColor: "transparent",width:"fit-content" }}
          >
            <KeyboardBackspaceIcon />
           <span style={{marginLeft:"10px"}}>Back To List</span>
          </button>
        </div>
        <div className="box">
          <div className="container mt-4">
            <div className="row">
              <div className="col-md-12 mt-3">
                <h6  className="d-block mb-2"
  style={{
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#374151",
  }}>Vechicle*</h6>
                <Box sx={{ minWidth: 120 }}>

                  <Autocomplete
                                      options={getAllVehicle}
                                      getOptionLabel={(option: any) => option.vehicleName}
                                      value={
                                        getAllVehicle.find(
                                          (v: any) => v._id === addFuel.vehicle?.vehicleId
                                        ) || null
                                      }
                                      onInputChange={(event, newInputValue) => {
                                        setSearchVehicle(newInputValue);
                                      }}
                                      onChange={(event, newValue: any) => {
                                        if (newValue) {
                                          handleChangeForVehicle({
                                            target: { value: newValue._id },
                                          });
                                        } else {
                  
                                          handleChangeForVehicle({
                                            target: { value: "" },
                                          });
                                        }
                                      }}
                                      clearOnEscape
                                      ListboxProps={{
                                        sx: {
                                          backgroundColor: "#fff",
                                          color: "#000",
                                          '& .MuiAutocomplete-option': {
                                            color: '#000',
                                          }
                                        },
                                      }}
                                      renderInput={(params) => (
                                        <TextField {...params} label="Search or Select Vehicle" />
                                      )}
                                    />
                </Box>
              </div>
              <div className="col-md-6 mt-3">
                <h6  className="d-block mb-2"
  style={{
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#374151",
  }}>Added Driver*</h6>
                <Box sx={{ minWidth: 120 }}>
<Autocomplete
                                      options={allDriver}
                                      getOptionLabel={(option: any) => option.driverName}
                                      value={
                                        allDriver.find(
                                          (v: any) => v._id === addFuel.driver.driverId
                                        ) || null
                                      }
                                      onInputChange={(event, newInputValue) => {
                                        setSearchDriver(newInputValue);
                                      }}
                                      onChange={(event, newValue: any) => {
                                        if (newValue) {
                                          handleChangeForDriver({
                                            target: { value: newValue._id },
                                          });
                                        } else {
                  
                                          handleChangeForDriver({
                                            target: { value: "" },
                                          });
                                        }
                                      }}
                                      clearOnEscape
                                      ListboxProps={{
                                        sx: {
                                          backgroundColor: "#fff",
                                          color: "#000",
                                          '& .MuiAutocomplete-option': {
                                            color: '#000',
                                          }
                                        },
                                      }}
                                      renderInput={(params) => (
                                        <TextField {...params} label="Search or Select Driver" />
                                      )}
                                    />
                </Box>
              </div>
              <div className="col-md-6 mt-3">
                <h6  className="d-block mb-2"
  style={{
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#374151",
  }}>Fill Date</h6>
                <TextField
                  className="mt-1"
                  type="date"
                  name="maintenanceEndDate"
                  value={
                addFuel.fillDate
                    ? new Date(addFuel.fillDate).toISOString().split("T")[0]
                    : ""
                }
                  onChange={(e) =>
                    setAddFuel({
                      ...addFuel,
                      fillDate: new Date(e.target.value).getTime(),
                    })
                  }
                  sx={{ height: "48px", width: "100%" }}
                />{" "}
              </div>
              <div className="col-md-6 mt-3">
                <h6  className="d-block mb-2"
  style={{
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#374151",
  }}>Quantity</h6>
                <TextField
                  id="outlined-basic"
                  placeholder="Quantity"
                  name="quantity"
                  type="number"
                  value={addFuel.quantity}
                  onChange={(e) => handleChange(e)}
                  fullWidth
                  sx={{
                    "& .MuiInputBase-input": {
                      padding: "12px",
                    },
                  }}
                />
              </div>
              <div className="col-md-6 mt-3">
                <h6  className="d-block mb-2"
  style={{
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#374151",
  }}>Odometer Reading</h6>
                <TextField
                  id="outlined-basic"
                  name="odometerReading"
                  type="text"
                  value={addFuel.odometerReading}
                  onChange={(e) => handleChange(e)}
                  placeholder="Odometer Reading"
                  variant="outlined"
                  fullWidth
                  sx={{
                    "& .MuiInputBase-input": {
                      padding: "12px",
                    },
                  }}
                />
              </div>
              <div className="col-md-6 mt-3">
                <h6  className="d-block mb-2"
  style={{
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#374151",
  }}>Amount</h6>
                <TextField
                  id="outlined-basic"
                  placeholder="Amount"
                  name="amount"
                  type="text"
                  value={addFuel.amount}
                  onChange={(e) => handleChange(e)}
                  fullWidth
                  sx={{
                    "& .MuiInputBase-input": {
                      padding: "12px",
                    },
                  }}
                />
              </div>
              <div className="col-md-6 mt-3">
                <h6  className="d-block mb-2"
  style={{
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#374151",
  }}>Comment</h6>
                <TextField
                  name="comment"
                  type="text"
                  value={addFuel.comment}
                  onChange={(e) => handleChange(e)}
                  placeholder="Comment"
                  variant="outlined"
                  fullWidth
                  sx={{
                    "& .MuiInputBase-input": {
                      padding: "12px",
                    },
                  }}
                />
              </div>
            </div>
          </div>
          {/* <div className="container mt-4">
            <div className="row">
              <div className="col-md-3">
                <h6>Odometer Reading</h6>
                <TextField
                  id="outlined-basic"
                  name="odometerReading"
                  type="text"
                  value={addFuel.odometerReading}
                  onChange={(e) => handleChange(e)}
                  placeholder="Odometer Reading"
                  variant="outlined"
                  fullWidth
                  sx={{
                    "& .MuiInputBase-input": {
                      padding: "12px",
                    },
                  }}
                />
              </div>
              <div className="col-md-3">
                <h6>Amount</h6>
                <TextField
                  id="outlined-basic"
                  placeholder="Amount"
                  name="amount"
                  type="text"
                  value={addFuel.amount}
                  onChange={(e) => handleChange(e)}
                  fullWidth
                  sx={{
                    "& .MuiInputBase-input": {
                      padding: "12px",
                    },
                  }}
                />
              </div>
              <div className="col-md-6">
                <h6>Comment</h6>
                <TextField
                  name="comment"
                  type="text"
                  value={addFuel.comment}
                  onChange={(e) => handleChange(e)}
                  placeholder="Comment"
                  variant="outlined"
                  fullWidth
                  sx={{
                    "& .MuiInputBase-input": {
                      padding: "12px",
                    },
                  }}
                />
              </div>
            </div>
          </div> */}
          <div className="container">
            <div className="row">
              <div className="col-md-12 mt-3">
                <h6></h6>
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  label={
                    <Typography fontWeight={700}>
                      Need to add in expense?
                    </Typography>
                  }
                />
              </div>{" "}
            </div>
          </div>
                        <div className="mt-4 aDD" style={{backgroundColor:"transparent"}}>
  <Button  onClick={handleSubmit} disabled={loading} style={{ textTransform: "none",fontWeight:"600",width:"auto" }}>
    {loading ? (
      <>
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
          className="me-2"
        />
        {isEdit ? "Edit..." : "Add..."}
      </>
    ) : (
      isEdit ? "Edit Fuel" : "Add Fuel"
    )}
  </Button>
</div>{" "}
        </div>
      </div>
    </>
  );
};

export default Addfuel;
